export default __webpack_public_path__ + "static/zasady_gry-734fa886138c69798f1e50ed5bfef033.mp3";